<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication" role="doc-dedication">
<p class="ded"><span aria-label="page vii" epub:type="pagebreak" id="page_vii" role="doc-pagebreak"><i>For Kathy and Pat, with best love</i></span></p>
<p class="ded1"><i>And to the Deep State: thank you for your service</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?64488d72